import {Dimensions, StyleSheet} from 'react-native';

const {width} = Dimensions.get('window');

export const styles = StyleSheet.create({
  container: {marginTop: 10},
  child: {
    width: width - 200,
    justifyContent: 'center',
    marginRight: 40,
  },
  textStyle: {
    textAlign: 'left',
    marginVertical: 10,
  },
  skeleton: {
    flex: 1,
    marginTop: 10,
  },
  divider: {
    minWidth: Dimensions.get('screen').width,
    marginLeft: -20,
    marginVertical: 5,
  },
});
